import { format } from 'date-fns/fp'
import moment from 'moment'

export const getFormattedDate = (timeStamp: string): string => {
  return moment(timeStamp, moment.ISO_8601, true).isValid()
    ? format('dd/MM/yyyy', new Date(timeStamp))
    : ''
}
